window.slate = window.slate || {};
window.theme = window.theme || {};

/***************** GLOBAL *****************/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

gsap.to(".js-paralax__box", {
  yPercent: 0,
  ease: "power3",
  scrollTrigger: {
    trigger: ".js-paralax",
    // start: "top bottom", // the default values
    // end: "bottom top",
    scrub: true,
    duration: 0.2
  },
});

gsap.to(".js-paralax__box2", {
  yPercent: -10,
  ease: "power3",
  scrollTrigger: {
    trigger: ".js-paralax",
    // start: "top bottom", // the default values
    // end: "bottom top",
    scrub: true,
    duration: 0.5
  },
});

/*const delSections = document.querySelectorAll(".gs_reveal");

delSections.forEach(section => {
  const containerAnim = gsap.to(section.querySelector(".pImage"), {
    yPercent: 30,
    //y: "100vh",
    ease: "none"
  });

  const imageAnim = gsap.to(section.querySelector("img"), {
    yPercent: -30,
    ease: "none",
    paused: true
  });

  const scrub = gsap.to(imageAnim, {
    progress: 1,
    paused: true,
    ease: "power3",
    duration: 4,
    overwrite: true
  });

  ScrollTrigger.create({
    animation: containerAnim,
    scrub: true,
    trigger: section,
    start: "top bottom",
    end: "bottom top",
    onUpdate: self => {
      scrub.vars.progress = self.progress;
      scrub.invalidate().restart();
    }
  });
});*/


/***************** TEMPLATES *****************/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  function checkError() {
    const hash = window.location.hash ? window.location.hash : window.location.pathname;
    const forms = document.querySelectorAll('[data-handle]')

    forms.forEach(function(item) {
      const itemHandle = item.getAttribute('data-handle');

      if (hash !== itemHandle) {
        item.classList.add('inactive--error');
      }
    });
  }

  checkError();
})();

;(function() {
  const product = document.querySelector('[data-custom-product]');
  if(!product) {
    return;
  }

  const variantSelect = product.querySelector('[data-custom-select]');
  const variantOptions = variantSelect.querySelectorAll('[data-search]');
  const handle = window.location.pathname;
  const search = window.location.search.replace('?', '');

  const getPdpJson = function(json) {
    let hasContent = false;
    json.options.forEach(function(option) {
      if(option.search_id === search) {
        console.log(option);
        console.log(".//./////////");
        setPdpContent(option);
        hasContent = true;
      }
    });

    if (!hasContent) {
      const tabs = document.querySelector('[data-tabs]');
      tabs.remove();
    }
  }

  const setContent = function(element, content) {
    content.length ? element.textContent = content : element.remove();
  }

  const calculatePrice = function (mainPrice) {
    let totalPrice = parseInt(mainPrice);
    $('input[data-price]').each(function () {
      if ($(this).val() !== '' && $(this).data('price') !== '') {
        totalPrice += parseInt($(this).data('price'));
      }
    });

    $('option[data-price]:selected').each(function (){
      if ($(this).data('price') !== '') {
        totalPrice += parseInt($(this).data('price'));
      }
    });

    return totalPrice;
  }

  const getOptionSelectors = function(options, showStonesSelector, stonesLists) {
    if(!options) {
      return;
    }

    const optionSelectorWrapper = product.querySelector('[data-custom-selectors-wrapper]');
    const optionInfoWrapper = product.querySelector('[data-info-wrapper]');

    options.forEach(function(option, ind) {
      const options = option.options.split(',');
      let optionsHtml = '';

      const regex = /\[\d*\]/gm;

      if (option.options.replace(regex, '').length) {
        let price = '';
        let priceMatch = 0;
        options.forEach(function (optionItem, ind) {
          priceMatch = regex.exec(optionItem);
          price = priceMatch ? priceMatch[0].replace('[', '').replace(']', '')*100 : '';
          optionsHtml += `
            <option data-price="${price}"
              value="${optionItem.replace(regex, '').toLowerCase().replace(' ', '')}">${optionItem.replace(regex, '')}${(price ? ' (+' + slate.Currency.formatMoney(price, theme.moneyFormat) + ')' : '')}</option>
          `;
        });

        optionSelectorWrapper.insertAdjacentHTML('beforeEnd', `
          <div class="selector-wrapper js-required-field-wrapper js">
            <div class="form__label-wrapper">
              <label class="form__label with--border" for="SingleOptionSelector-${ind}">
                ${option.title}
              </label>

              ${option.title === 'Ring Size1' ? optionInfoWrapper.outerHTML : ``}
              ${option.info}
            </div>

            <select
              class="form__input select--input${option.required ? ' js-required-field' : ''}"
              id="SingleOptionSelector-${ind}"
              data-single-option-selector
              name="properties[${option.title}]"
              ${option.title === 'Ring Size' ? `data-option-ring-size-select` : ``}
              data-index="option${ind}">
              <option selected="selected" value="">
                Select Your ${option.title}
              </option>
              ${optionsHtml}
            </select>

            ${option.required ? `<p class="form__error-message hide js-required-error-message">
                        Please make ${option.title} selection
                      </p>` : ''}

            ${option.caption.length ? '<span class="form__input-caption">'+option.caption+'</span>' : ''}
          </div>
        `);
      } else {
        let priceMatch = regex.exec(option.options);
        let price = priceMatch ? priceMatch[0].replace('[', '').replace(']', '')*100 : '';
        optionSelectorWrapper.insertAdjacentHTML('beforeEnd', `
          <div class="selector-wrapper js-required-field-wrapper js">
            <div class="form__label-wrapper">
              <label class="form__label with--border" for="SingleOptionInput-${ind}">
                ${option.title}${(price ? ' (+' + slate.Currency.formatMoney(price, theme.moneyFormat) + ')' : '')}
              </label>

              ${option.title === 'Ring Size1' ? optionInfoWrapper.outerHTML : ``}
              ${option.info}
            </div>

            <input
              class="form__input select--input${option.required ? ' js-required-field' : ''}"
              id="SingleOptionInput-${ind}"
              data-price="${price}"
              data-single-option-input
              name="properties[${option.title}]"
              ${option.title === 'Ring Size' ? `data-option-ring-size-select` : ``}
              data-index="option${ind}" />

              ${option.required ? `<p class="form__error-message hide js-required-error-message">
                      Please fill in your ${option.title}
                    </p>` : ''}

              ${option.caption.length ? '<span class="form__input-caption">'+option.caption+'</span>' : ''}
          </div>
        `);
      }
    });

    stonesLists.forEach(stonesList => {
      let lightbox = document.getElementById(stonesList);

      if (lightbox) {
        optionSelectorWrapper.insertAdjacentHTML('beforeEnd', `
        <div class="selector-wrapper stones-selector" data-stone-list="`+stonesList+`">
          <div class="form__label-wrapper">
            <label class="form__label with--border" for="StonesSelector">
              `+stonesList.replace('-', ' ').toUpperCase()+`
            </label>
          </div>

          <div class="stones-list__value"></div>
          <input class="js-stone-list-property" name="properties[` + stonesList.replace('-', ' ') + `]" type="hidden" value="">
          <a href="#`+stonesList+`" data-fancybox="`+stonesList+`" data-options='{"baseClass": "custom-lightbox", "touch": false, "arrows": false, "infobar": false, "hash": false}' class="stones-list__opener">Select your stone</a>
        </div>
      `);
      }
    });

    if (showStonesSelector == 'true') {
      optionSelectorWrapper.insertAdjacentHTML('beforeEnd', `
        <div class="selector-wrapper stones-selector" data-stone-list="stones_list">
          <div class="form__label-wrapper">
            <label class="form__label with--border" for="StonesSelector">
              COLLECTORS EDITION
            </label>
          </div>

          <div class="stones-list__value"></div>
          <a href="#stones_list" data-fancybox="stones-list" data-options='{"baseClass": "custom-lightbox", "touch": false, "arrows": false, "infobar": false, "hash": false}' class="stones-list__opener">Select your stone</a>
        </div>
      `);
    }

    jcf.replaceAll('[data-custom-selectors-wrapper]');

    validateCustomForm();

    //document.getElementsByTagName('body')[0].classList.remove('page-loading');
  }

  const setPdpContent = function(currentVariant) {
    const title = product.querySelector('[data-custom-title]');
    const price = product.querySelector('[data-custom-price]');
    const image = product.querySelector('[data-custom-image]');
    const addToCart = product.querySelector('[data-custom-add-to-cart]');
    const customSelectorsWrapper = product.querySelector('[data-custom-selectors-wrapper]');
    const shortDescription = product.querySelector('[data-custom-short-description]');
    const inquireSelector = product.querySelector('[data-inquire-selector]');

    const tabs = document.querySelector('[data-tabs]');
    const descriptionTitles = tabs.querySelectorAll('[data-tab-title]');
    const descriptionTitlesMobile = tabs.querySelectorAll('[data-tab-title-mobile]');
    const descriptionContents = tabs.querySelectorAll('[data-tab-content]');

    const galleries = document.querySelectorAll('[data-pdp-images]');
    const featuredCollections = document.querySelectorAll('[data-pdp-collections]');
    // video variant
    let videoList;
    const isCustomProduct = document.querySelector(".pdp").classList.contains("custom-pdp");

    if(isCustomProduct) {
      //custom pdp
      videoList = currentVariant.video;
    } else {
      videoList = product.querySelectorAll('[data-pdp-video]');
    }

    setContent(title, currentVariant.name);
    setContent(price, slate.Currency.formatMoney(currentVariant.price, theme.moneyFormat));
    setContent(shortDescription, currentVariant.short_description);

    if(currentVariant.image.length && image !== null) {
      image.setAttribute('src', currentVariant.image);
    }

    if (currentVariant.gallery && currentVariant.gallery.length && image !== null) {
      let imagesHtml = document.createElement('div', );
      imagesHtml.setAttribute('class', 'pdp__images-list');
      imagesHtml.setAttribute('data-main-pdp-slideshow', '');
      let imageList = '';

      currentVariant.gallery.forEach((image,i) => {
        imageList += `<div data-media-id="${image.id}" class="" data-slider-counter="${i}">
              <a data-fancybox="pdp-gallery" href="${image.cloudinary_src}">
                <img class="pdp__image"
                     src="${image.cloudinary_src}"
                     alt="${image.alt}">
              </a>
            </div>`;
      });
      
      if (videoList?.length) {
        // last media gallery element index, before video, only images
        let lastGaleryElement = currentVariant.gallery.length;
        videoList.forEach((video,i) => {
          let videoJson;
          isCustomProduct ? videoJson = video : videoJson = JSON.parse(video.innerHTML);
          imageList += `<div data-media-id="${videoJson.id}" class="" data-slider-counter="${lastGaleryElement++}">
          <video class="pdp__video" autoplay="autoplay" playsinline="playsinline" loop="loop" muted="muted" width="800">
            <source src="${videoJson.src}" type="${ videoJson.mime_type }">
          </video>
        </div>`;
        }
      );
    }


      imagesHtml.innerHTML = imageList;
      image.replaceWith(imagesHtml);

      jQuery(document).trigger('customPdpGalleryLoaded');
    }

    if (location.href.includes(localStorage.getItem('enable_inquire'))) {
      inquireSelector.classList.remove('hide');
    }

    if (galleries.length) {
      galleries.forEach(images => {
        if (currentVariant.value_id == images.getAttribute('data-variant-id')) {
          images.style.display = 'block';
        }
      });
    }

    if (featuredCollections.length) {
      featuredCollections.forEach(collection => {
        if (currentVariant.value_id == collection.getAttribute('data-variant-id')) {
          collection.style.display = 'block';
        }
      });
    }

    let hasTabs = false;
    if(currentVariant.descriptions) {
      currentVariant.descriptions.forEach(function(description, i) {
        if (descriptionTitles[i] !== null && descriptionTitles[i] !== undefined) {
          descriptionTitles[i].textContent = description.title;
          descriptionTitlesMobile[i].textContent = description.title;
          descriptionContents[i].textContent = description.content;

          setContent(descriptionTitles[i], description.title);
          setContent(descriptionTitlesMobile[i], description.title);
          setContent(descriptionContents[i], description.content);

          hasTabs = true;
        }
      });
    }

    if (!hasTabs) {
      tabs.style.dispay = 'none';
    }

    if (currentVariant.value == 0) {
      addToCart.setAttribute('data-soldout', true);
      addToCart.disabled = true;
      addToCart.innerText = 'Sold out, for now';
      customSelectorsWrapper.classList.add('pdp__options-wrapper--transparent');
    }

    getOptionSelectors(currentVariant.options, currentVariant.show_stones, currentVariant.stones_lists);

    let totalPrice = calculatePrice(currentVariant.price);
    setContent(price, slate.Currency.formatMoney(totalPrice, theme.moneyFormat));
    $('[name="properties[_price]"]').val(totalPrice);
    $(document).trigger('validateCustomForm');

    $('body').on('input', 'input[data-price]', function () {
      if ($(this).val() !== '') {
        let totalPrice = calculatePrice(currentVariant.price);
        setContent(price, slate.Currency.formatMoney(totalPrice, theme.moneyFormat));
        $('[name="properties[_price]"]').val(totalPrice);
      }
    });

    $('body').on('change', $('option[data-price]').closest('select'), function () {
        let totalPrice = calculatePrice(currentVariant.price);
        setContent(price, slate.Currency.formatMoney(totalPrice, theme.moneyFormat));
        $('[name="properties[_price]"]').val(totalPrice);
    });

  }

  variantOptions.forEach(function(option) {
    const optionSearch = option.getAttribute('data-search');

    if(optionSearch === search) {
      option.selected = true;
    }
  });


  console.log(handle);
  console.log("handle");
  
  fetch(`${handle}?view=custom-json`, {
    redirect: 'follow',
    credentials: 'include'
  }).then((response) => {
    response.json().then(function(parsedJson) {
      getPdpJson(parsedJson);
      document.getElementsByTagName('body')[0].classList.remove('page-loading');
      jQuery('.pdp__images-list').slick('resize');
    })
  });
}());

;(function() {
  const backButton = document.querySelector('[data-back-url]');

  if(!backButton) {
    return;
  }
  const backButtonUrl = backButton.getAttribute('href');
  const urlParams = window.location.search.split('__');
  let newUrlParams = [];

  urlParams.forEach(function(param) {
    if(param.indexOf('last-step~') === -1) {
      newUrlParams.push(param);
    }
  });

  const url = newUrlParams.join('__');
  const getCustomizerPage = function(evt) {
    evt.preventDefault();

    document.location.href = backButtonUrl + url;
  }

  backButton.addEventListener('click', getCustomizerPage);
}());

/* close & exit button */
;(function() {
  const exitButton = document.querySelector('[data-close-page]');

  if(!exitButton) {
    return;
  }

  const getPrevPage = function(evt) {
    evt.preventDefault();
    const prevPage = Cookies.get('prevPage');

    if(!prevPage) {
      document.location.href = '/';
      return;
    }

    document.location.href = prevPage;
  }

  exitButton.addEventListener('click', getPrevPage);
}());


/* detected url from facebook */
;(function() {
  const searchUrl = window.location.search;

  if(searchUrl.indexOf('fbclid') === -1) {
    return;
  }

  const hrefUrl = document.location.pathname;
  if(searchUrl.indexOf('&fbclid') !== -1) {
    var newUrlParams = searchUrl.split('&fbclid')[0];
  } else {
    var newUrlParams = searchUrl.split('?fbclid')[0];
  }

  document.location.href = hrefUrl + newUrlParams // +  '=';
}());


/*$(function() {
  $('[data-fancybox]').fancybox({
    afterClose: function(instance, data){
     $(data.src).show();
    },
  });
});*/

$(function() {
  let valueSelector = '.stones-list__value';

  $('body').on('change', '.stone-item__field', function() {
    let $container = $('[data-stone-list="'+$(this).closest('.fancybox-content').find('.stones-lightbox__close').attr('href').replace('#', '')+'"]');
    let valueTemplate = $('<a href="#" class="stones-list__clear"></a>').on('click', function(e) {
      e.preventDefault();
      $(valueSelector, $container).html('');
      $('.stone-item__field:checked').prop('checked', false).trigger('change');
    });
    $container.find('.js-stone-list-property').val($(this).val())
    $(valueSelector, $container).html(valueTemplate.text($(this).val()));
    $container.removeClass('has-error').find('.error').remove();
    $.fancybox.getInstance().close(true);
  });
});


function validateCustomForm() {
  let $form = $('.pdp [action="/cart/add"]');
  let $fields = $('select, input:not([type="radio"]):not([type="hidden"]):not([type="submit"]), input[name="properties[Stone]"], textarea', $form);
  let $btn = $('[data-custom-add-to-cart],[data-add-to-cart]', $form);

  $fields.on('change input', function() {
    validateForm();

    if ($(this).val() !== '') {
      removeError($(this));
    }
  });

  function validateForm() {
    // if (isFormReady()) {
    //   $btn.prop('disabled', false).unwrap('span.validate');
    // } else {
    //   $btn.prop('disabled', true).wrap('<span class="validate"></span>');
    // }
  }

  if ($btn.attr('data-soldout') === undefined) {
    validateForm();
  }

  function isFormReady() {
    let formValid = true;
    let hasStoneChecked = false;

    $fields.each(function() {
      if ($(this).attr('name') == 'properties[Stone]' && $(this).is(':checked')) {
        hasStoneChecked = true;
      }
      if ($(this).attr('name') !== undefined) {
        console.log($(this).attr('name') ,$(this).val())
      }
      if ($(this).attr('name') !== undefined && $(this).val() == '') {
        formValid = false;
      }
    });
    if (!hasStoneChecked) {
      formValid = false;
    }

    return formValid;
  }

  function addError($field) {
    // let hasErrorClass = 'has-error';
    // if ($field.attr('name') == '') {
    //   $wrapper = $('.stones-selector', $form).closest('.selector-wrapper');
    // } else {
    //   $wrapper = $field.closest('.selector-wrapper');
    // }
    //
    // if (!$wrapper.hasClass(hasErrorClass)) {
    //   $wrapper.addClass(hasErrorClass).append('<div class="error">' + ( $field.prop('tagName') == 'INPUT' && $field.attr('type') == 'text' ? "Can't be empty" : 'Make your selection' ) + '</div>');
    // }
  }

  function removeError($field) {
    // let hasErrorClass = 'has-error';
    // if ($field.attr('name') == '') {
    //   $wrapper = $('.stones-selector', $form).closest('.selector-wrapper');
    // } else {
    //   $wrapper = $field.closest('.selector-wrapper');
    // }
    //
    // if ($wrapper.hasClass(hasErrorClass)) {
    //   $wrapper.removeClass(hasErrorClass).find('.error').remove();
    // }
  }

  function handleErrors() {
    let hasStoneChecked = false;

    $fields.each(function() {
      if ($(this).attr('name') == 'properties[Stone]' && $(this).is(':checked')) {
        hasStoneChecked = true;
      }
      if ($(this).attr('name') !== undefined) {
        if ($(this).val() == '') {
          addError($(this))
        } else {
          removeError($(this))
        }
      }
    });
    if (!hasStoneChecked) {
      addError($('.stones-selector', $form));
    } else {
      removeError($('.stones-selector', $form));
    }
  }

  $btn.parent('.validate').on('click', function() {
    handleErrors();
  });
}


/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {
  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    optionsPrice: '[data-option-price]',
    customPrice: '[data-main-prices]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantChange' + this.namespace, this.customPriceRecalculation.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateProductImage.bind(this));

    var self = this;
    $(selectors.optionsPrice, this.$container).on('input', function () {
      self.customPriceRecalculation({variant: self.variants.currentVariant});
    });
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */

    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;

      if(!variant.featured_image) {
        return;
      }

      const featuredImageId = jQuery('[data-media-id="' + variant.id + '"]:not(.slick-cloned)');
      const featuredImageInitial = featuredImageId.data('slick-index');
      jQuery(jQuery('#slick-slide-control0' + featuredImageInitial)).trigger('click');
    },

    customPriceRecalculation: function (evt) {
      var variant = evt.variant;
      let prices = $(selectors.customPrice).data('main-prices');

      if (prices) {
        let newPrice = 0;
        prices.forEach(price => {
          if (price.id == variant.id) {
            newPrice = this.calculatePrice(price.price);
            $(selectors.customPrice).val(newPrice);

            $(selectors.productPrice, this.$container)
              .html(slate.Currency.formatMoney(newPrice, theme.moneyFormat));
          }
        })
      }
    },

    calculatePrice: function (mainPrice) {
      let totalPrice = parseInt(mainPrice);
      jQuery(selectors.optionsPrice).each(function () {
        if (jQuery(this).prop('tagName') == 'INPUT') {
          if (jQuery(this).val() !== '' && jQuery(this).data('option-price') !== '') {
            totalPrice += parseInt(jQuery(this).data('option-price'));
          }
        } else if (jQuery(this).prop('tagName') == 'OPTION' && jQuery(this).is(':selected')) {
          if (jQuery(this).data('option-price') !== '') {
            totalPrice += parseInt(jQuery(this).data('option-price'));
          }
        }
      });

      return totalPrice;
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

(function () {
  function sliderPdp() {
    const sliderPdp = jQuery('[data-main-pdp-slideshow]');
    const sliderPdpActive = sliderPdp.find('.slick-current--custom')[0] || 0;
    const sliderPdpActiveInd = jQuery(sliderPdpActive).data('slider-counter') - 1;

    sliderPdp.slick({
      slidesToScroll: 1,
      rows: 0,
      adaptiveHeight: true,
      arrows: false,
      dots: true,
      //fade: true,
      //cssEase: 'linear'
      //initialSlide: sliderPdpActiveInd
    });
  }

  sliderPdp();

  jQuery(document).on('customPdpGalleryLoaded', sliderPdp);
})();

// Recomendation products
(function () {
  var loadProductRecommendationsIntoSection = function() {
// Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) { return; }
// Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;
// Read base URL from data attribute
    var baseUrl = productRecommendationsSection.dataset.baseUrl;
// Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;
// Build request URL
    var requestUrl = baseUrl + "?section_id=pdp-recommendations&product_id=" + productId;
// Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      }
    };
    request.send();
  };

// Listen for changes done in the Theme Editor
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
// Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();
})();

// init openClose
(function () {
  jQuery('.js-pdp-open-close').openClose({
    activeClass: 'pdp--tab-active',
    opener: '.js-opener-tabset',
    slider: '.js-pdp__tab-slide',
    animSpeed: 400,
    hideOnClickOutside: true,
    effect: 'slide'
  });
})();

(function () {
  jQuery('.js-pdp__tabset').tabset({
    tabLinks: 'a',
    addToParent: true,
    attrib: 'data-tab',
    defaultTab: true
  });
})();

const getCustomSize = function() {
  const button = document.querySelector('[data-custom-size]');
  const sizeText = document.querySelector('[data-custom-size-text]');
  const sizeTextInner = document.querySelector('[data-custom-size-text-inner]');
  const sizeSelect = document.querySelector('[data-option-ring-size-select]');
  const sizeInput = document.querySelector('[data-custom-size-input]');
  const sizeInputTarget = document.querySelector('[data-custom-size-input-target]');
  const sizePopupOpener = document.querySelector('[data-popup-trigger="custom-size"]');
  let sizeOptionSaved = '';
  const targetOption = 'other';

  function modifyValue() {
    const sizeInputValue = sizeInput.value;

    if(sizeInputValue.length > 0) {
      sizeTextInner.innerText = sizeInputValue;
      sizeInputTarget.value = sizeInputValue;
      sizeText.classList.remove('hide');
      sizeOptionSaved = sizeSelect.value;
      sizeSelect.value = targetOption;
      $(sizeSelect).trigger('change');
    } else {
      sizeText.classList.add('hide');
      sizeSelect.value = sizeOptionSaved;
      $(sizeSelect).trigger('change');
      sizeTextInner.innerText = ``;
      sizeInputTarget.value = ``;
    }
  }

  function modifyCustomSize(e) {
    if(e.target.value !== targetOption) {
      sizeText.classList.add('hide');
      sizeTextInner.innerText = ``;
      sizeInput.value = ``;
    } else {
      $(sizePopupOpener).trigger('click');
    }
  }

  if(button) {
    button.addEventListener('click', modifyValue);
  }
  if(sizeSelect) {
    sizeSelect.addEventListener('change', modifyCustomSize);
  }
};

function validateForm(form) {
  const emailRegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  const fields = form.querySelectorAll('[required]');
  const submitButton = form.querySelector('.send');
  const errorClass = ('input--error');
  const errorParentClass = ('input--error-holder');

  function validateInput(e) {
    fields.forEach(function(field) {
      const type = field.type;
      const parent = field.closest('.inp');

      if(field.value.length !== 0 && type === 'text' || emailRegExp.test(field.value) && type === 'email') {
        field.classList.remove(errorClass);
        parent.classList.remove(errorParentClass);
      } else {
        field.classList.add(errorClass);
        parent.classList.add(errorParentClass);
      }
    });
  }

  submitButton.addEventListener('click', validateInput);
}

;(function() {
  const dpHintButton = jQuery('.drophint-link');

  const timerId = function() {
    const dropaForm = document.querySelector('#dropaform');

    if(dropaForm) {
      const dropaFormClose = document.querySelector('.clz');

      validateForm(dropaForm);
      clearInterval(intervalID);
      dropaFormClose.addEventListener('click', initInterval);
    }
  };

  function initInterval() {
    intervalID = window.setInterval(timerId, 1000);
  }

  if(dpHintButton) {
    initInterval();
  }
}());

;(function() {
  const numberInputList = document.querySelectorAll("[data-only-numbers]");

  function modifyInput() {
    const min = this.getAttribute('min');
    const max = this.getAttribute('max');
    let newValue = this.value.replace(/[^\d]+/g,'');

    if(parseInt(newValue, 10) > parseInt(max, 10)) {
      newValue = newValue.replace(newValue, max);
    }
    if(parseInt(newValue, 10) < parseInt(min, 10)) {
      newValue = newValue.replace(newValue, min);
    }

    this.value = newValue;
  }

  numberInputList.forEach(function(item) {
    item.addEventListener('input', modifyInput);
  });
}());

setTimeout(getCustomSize, 1000);

// Scroll to top on challenge page

(function () {
  const challenge = document.querySelector(`#challenge`);
  if(!challenge) return;

  const challengeScroll = function() {
    window.scroll({
      top: 10,
      behavior: `smooth`
    });
  }

  setTimeout(challengeScroll, 1500);
})();

// Customizer page

(function () {
  function someHeight() {
    const heightContainers = document.querySelectorAll('[data-height]');

    heightContainers.forEach(function(heightContainer) {
      const heightItems = heightContainer.querySelectorAll('[data-height-element]');
      let minHeight = 0;

      heightItems.forEach(function(heightItem) {
        const height = heightItem.offsetHeight;

        if(minHeight < height) {
          minHeight = height;
        }
      });

      heightItems.forEach(function(heightItem) {
        heightItem.style.minHeight = `${minHeight}px`;
      });
    });
  }

  /*let $slider = jQuery('[data-step-slider]');

  $slider.slick({
    slidesToShow: 3,
    slidesToScroll: 2,
    arrows: false,
    infinite: false,
    rows: 0,
    touchMove: false,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });

  $slider.on('wheel', (function(e) {
    e.preventDefault();

    if (e.originalEvent.deltaY < 0) {
      $(this).slick('slickNext');
    } else {
      $(this).slick('slickPrev');
    }
  }));*/

  someHeight();
})();

window.addEventListener('load', function () {
  if (window.innerWidth < 668) {
    let lists = document.querySelectorAll('[data-step-slider]');

    lists.forEach(list => {
      let items = list.children;

      list.style.width = (items.length * parseInt(items[0].offsetWidth) + 40)+'px';
    });
  }
});

window.addEventListener('resize', function () {
  let lists = document.querySelectorAll('[data-step-slider]');

  lists.forEach(list => {
    let items = list.children;

    list.style.width = (items.length * parseInt(items[0].offsetWidth) + 40)+'px';
  });
});

const setPrevUrl = function() {
  const thisPage = document.location.href;
  const prevPage = document.referrer;
  const productUrl = document.querySelector('[data-pdp-url]').getAttribute('data-pdp-url');

  if(!prevPage || prevPage === thisPage || prevPage.indexOf(productUrl) !== -1 || prevPage.indexOf('/pages/customizer') !== -1) {
    return;
  }

  Cookies.set('prevPage', prevPage);
}

const changeHeight = function() {
  const stepsHeight = document.querySelector('[data-steps-height]');
  if(!stepsHeight) {
    return;
  }
  const stepHeightElement = stepsHeight.querySelectorAll('.step--active [data-steps-height-active]');

  if(stepHeightElement.length < 1) {
    stepsHeight.setAttribute('style',`height: auto`);
    return;
  }
  const stepHeight = stepHeightElement[stepHeightElement.length - 1].offsetHeight;

  stepsHeight.setAttribute('style',`height: ${stepHeight}px`);
};

(function () {
  if (!Shopify.designMode) {

    window.addEventListener('load', function() {
      if (document.body.id == 'customizer' && Cookies.get('customizer_flow') == window.location.href) {
        document.querySelector('.step--current [data-prev-step]').setAttribute('disabled', true);
        document.querySelector('.step--current [data-prev-step]').style.display = 'none';
      }
    });

    const nextButton = ('[data-next-step]');
    const prevButton = ('[data-prev-step]');
    const nextButtons = document.querySelectorAll(nextButton);
    const prevButtons = document.querySelectorAll(prevButton);
    const stepName = ('[data-step-name]');
    const stepTargetName = ('[data-step-target-name]');
    const stepTargets = document.querySelectorAll(stepTargetName);
    const stepActive = ('step--active');
    const stepCurrent = ('step--current');
    const sharingLinks = document.querySelectorAll('[data-social-href]');

    const stepCount = function(stepSize) {
      const counts = document.querySelectorAll('.step--active [data-step-count]');

      if(counts[counts.length - 1]) {
        counts[counts.length - 1].textContent = '0' + (stepSize + 1);
      }
    }

    const undisabled = function(event) {
      const parent = event.target.closest(stepName);
      const parentButton = parent.querySelector(nextButton);
      const activeStepValue = event.target.value;
      const activeStep = document.querySelector(`[data-step-name="${activeStepValue}"]`);

      activeStepValue&&activeStep || activeStepValue === 'end' ? parentButton.removeAttribute('disabled') : parentButton.setAttribute('disabled', true);
    }

    const changeUrl = function(urlValue, checkedName) {
      const urlParams = window.location.search;
      const handle = urlParams.length ? urlParams + '__' + checkedName + '~' + urlValue : '?' + checkedName + '~' + urlValue;

      history.pushState({}, null, window.window.location.pathname + handle);
      sharingLinks.forEach(sharingLink => {
        sharingLink.setAttribute('data-social-href', sharingLink.getAttribute('data-social-href').replace(/site\s{1}([^*]*)\*/, 'site '+window.window.location.href+'*'));
        sharingLink.setAttribute('href', sharingLink.getAttribute('href').replace(/site\s{1}([^*]*)$/, 'site '+window.window.location.href));
      });
      nextStep();
    }

    const reChangeUrl = function() {
      const urlParams = window.location.search.split('__');
      let newUrl = ''

      urlParams.forEach(function(urlParam, index) {
        if(index !== urlParams.length - 1) {
          newUrl = index === 0 ? newUrl + urlParam : newUrl + '__' + urlParam;
        }
      });

      history.pushState({}, null, window.window.location.pathname + newUrl);
      sharingLinks.forEach(sharingLink => {
        sharingLink.setAttribute('data-social-href', sharingLink.getAttribute('data-social-href').replace(/site\s{1}([^*]*)\*/, 'site '+window.window.location.href+'*'));
        sharingLink.setAttribute('href', sharingLink.getAttribute('href').replace(/site\s{1}([^*]*)$/, 'site '+window.window.location.href));
      });
    }

    const getProduct = function() {
      let productUrl = document.querySelector('[data-pdp-url]').getAttribute('data-pdp-url');

      let realProductUrl = '';
      if (Cookies.get('customizer_flow')) {
        realProductUrl = productUrl;
        productUrl = '/pages/get-the-conversation-started';
      } else {
        Cookies.set('realProductUrl', '');
        let individualProductUrl = document.querySelector('.step--active [data-product]:checked');
        if (individualProductUrl !== undefined && individualProductUrl !== null) {
          productUrl = individualProductUrl.getAttribute('data-product');
        }
      }
      const currentStepValue = document.querySelector('.step--active.step--current [value="end"]:checked');
      const productHash = currentStepValue ? currentStepValue.getAttribute('data-hash') : '';
      const productSearch = window.location.search;

      if (realProductUrl.length) {
        Cookies.set('realProductUrl', realProductUrl + productSearch + '__last-step~' + productHash + '=');
      }
      setTimeout(function() {
        document.location.href = productUrl + productSearch + '__last-step~' + productHash + '=';
      },1000);
    }

    const prevStep = function() {
      reChangeUrl();
      checkUrl();
      changeHeight();
    }

    const nextStepValue = function(event) {
      const parent = event.target.closest(stepName);
      const checkedValue = parent.querySelector(`${stepTargetName}:checked`).value;
      const checkedName = parent.querySelector(`${stepTargetName}:checked`).getAttribute('data-step-target-name');

      if (checkedValue !== 'end') {
        let item = parent.querySelector('input[value="'+checkedValue+'"]');
        let step = item.closest('[data-step-item]');
        if (step.getAttribute('data-has-inquire') !== null) {
          localStorage.setItem('enable_inquire', checkedValue);
        } else {
          localStorage.removeItem('enable_inquire');
        }
      }

      checkedValue === 'end' ? getProduct() : changeUrl(checkedValue, checkedName);
    }

    Array.prototype.diff = function(a) {
      return this.filter(function(i) {return a.indexOf(i) < 0;});
    };

    const removeOldActive = function(newActiveSteps) {
      const steps = document.querySelectorAll(`[data-step-name]`);
      let oldActiveSteps = [];

      steps.forEach(function(step) {
        const stepValue = step.getAttribute('data-step-name');

        if(stepValue.length) {
          oldActiveSteps.push(stepValue);
        }
      });

      const oldSteps = oldActiveSteps.diff(newActiveSteps);

      oldSteps.forEach(function(oldStep) {
        const step = document.querySelector(`[data-step-name="${oldStep}"]`);
        step.classList.remove(stepActive);
      });
    }

    const checkUrl = function() {
      let newActiveSteps = [];

      if(!window.location.search) {
        removeOldActive(newActiveSteps);
        return;
      }

      const searchParams = window.location.search.split('__');

      searchParams.forEach(function(param, index) {
        const activeStepName = param.split('~')[0].replace('?', '');
        const activeStepValue = param.split('~')[1];
        const activeStep = document.querySelector(`[data-step-name="${activeStepValue}"]`);

        if(!activeStep) {
          return;
        }

        activeStep.classList.add(stepActive);

        const activeInput = document.querySelector(`.step--active [data-step-target-name="${activeStepName}"]`);

        if(!activeInput) {
          return;
        }
        const buttonNext = activeInput.closest(stepName).querySelector(nextButton);

        activeInput.checked = true;
        buttonNext.removeAttribute('disabled');
        newActiveSteps.push(activeStepValue);
        activeStep.classList.remove(stepCurrent);

        if(searchParams.length === index + 1) {
          activeStep.classList.add(stepCurrent);

          if (Cookies.get('customizer_flow') && window.location.href == Cookies.get('customizer_flow')) {
            activeStep.querySelector(prevButton).setAttribute('disabled', true);
            activeStep.querySelector(prevButton).style.display = 'none';
          }
        }
      });

      removeOldActive(newActiveSteps);
      stepCount(searchParams.length);
    }

    const nextStep = function() {
      checkUrl();
      changeHeight();
    }

    const checkLastStep = function() {
      const lastStepInput = document.querySelector('.step--current [value="end"]:checked');

      if(lastStepInput) {
        lastStepInput.closest(stepName).querySelector(nextButton).removeAttribute('disabled');
      }
    }

    if(prevButtons.length) {
      prevButtons.forEach(function(button) {
        button.addEventListener('click', prevStep);
      });
    }

    if(nextButtons.length) {
      nextButtons.forEach(function(button) {
        button.setAttribute('disabled', true);
        button.addEventListener('click', nextStepValue);
      });
    }

    if(stepTargets.length) {
      stepTargets.forEach(function(stepTarget) {
        stepTarget.addEventListener('change', undisabled);
        stepTarget.addEventListener('change', nextStepValue);

        let stepLabel = document.querySelector('label[for="'+stepTarget.getAttribute('id')+'"]');
        stepLabel.addEventListener('click', function() {
          if (stepTarget.checked == true) {
            let event = {};
            event.target = stepLabel;
            nextStepValue(event);
          }
        });
      });

      addEventListener('popstate',function(e){
        checkUrl();
      },false);

      nextStep();
      setPrevUrl();
      centerCustomizerListVertically();
      setTimeout(checkLastStep, 1000);
    }
  }
})();

(function() {

   var items = document.querySelectorAll('.step__list-wrapper, .wizzard__list-wrapper');

    items.forEach(item => {
      item.onwheel = function(e) {
        var isTouchPad = e.wheelDeltaY ? e.wheelDeltaY === -3 * e.deltaY : e.deltaMode === 0;
        
        e.preventDefault();

        // if ( !isTouchPad ) {

          // if (e.deltaY > 0) {
          //   item.scrollLeft += 100;
          // } else {
          //   item.scrollLeft -= 100;
          // }

          item.scrollLeft += e.deltaY;

          item.scrollTop = 0;
        // }

      };

      /*item.addEventListener('mousedown', (e) => {
        isDown = true;
        item.classList.add('active');
        startX = e.pageX - item.offsetLeft;
        scrollLeft = item.scrollLeft;
      });
      item.addEventListener('mouseleave', () => {
        isDown = false;
        item.classList.remove('active');
      });
      item.addEventListener('mouseup', () => {
        isDown = false;
        item.classList.remove('active');
      });
      item.addEventListener('mousemove', (e) => {
        if(!isDown) return;
        e.preventDefault();
        const x = e.pageX - item.offsetLeft;
        const walk = (x - startX) * 3; //scroll-fast
        item.scrollLeft = scrollLeft - walk;
      });*/
    });

})();


$(function() {
  $('[data-customizer-action]').on('click', function(e) {
    e.preventDefault();

    Cookies.set('customizer_flow', $(this).attr('href'));

    window.location.href = $(this).attr('href');
  });

  $('[data-customizer-standard]').on('click', function(e) {
    e.preventDefault();

    Cookies.remove('customizer_flow');

    window.location.href = $(this).attr('href');
  });
});


// center blocks list vertically
function centerCustomizerListVertically() {
	if ($(window).width() > 667) {
		$('[data-step-slider]').each(function() {
			let $list = $(this);
			let $container = $list.closest('[data-steps-height-active]');
			let $header = $container.find('.customizer__header');

			$list.css('top', 'calc( 50% - '+$header.outerHeight()/2+'px )');
		});
	}
}

$(function() {
	$(window).on('resize load orientationchange', function() {
		centerCustomizerListVertically();
	});
});


/***************** BLOCKS *****************/
/*================ Header Block ================*/

// scroll header

(function () {
  const body = document.querySelector(`body`);
  const fixedHeader = document.querySelector(`[data-fixed-header]`);
  let lastPosition = window.scrollY;
  let scrollPos = 0;
  const defaultHeader = (`default--header`);
  const noHeader = (`no-header`);
  const headerHidden = (`header--hidden`);
  const ScrollDownClass = (`scroll-down`);
  const ScrollUpClass = (`scroll-up`);
  const ScrolledTopClass = (`scrolled-top`);

  const scroll = function() {
    if (window.screen.width < 1200) return true;
    const currentPosition = window.scrollY;
    let scrollPositionTop = (document.body.getBoundingClientRect()).top;

  if (scrollPositionTop === 0) {
    body.classList.remove(ScrollUpClass);
    body.classList.add(ScrolledTopClass);
  } else if (scrollPositionTop > scrollPos && currentPosition > 0) {
    body.classList.remove(ScrollDownClass);
    body.classList.add(ScrollUpClass);
	} else {

  		body.classList.remove(ScrollUpClass);
      body.classList.remove(ScrolledTopClass);
  		body.classList.add(ScrollDownClass);

	}
	// saves the new position for iteration.
	scrollPos = scrollPositionTop;

    if (currentPosition < lastPosition) {
      //fixedHeader.classList.remove(headerHidden);
      //body.classList.remove(noHeader);

      if(currentPosition <= 0) {
        fixedHeader.classList.add(defaultHeader);
      } else {
        fixedHeader.classList.remove(defaultHeader);
      }

    } else if (currentPosition >= lastPosition) {

      if (currentPosition < 250) return true;

      fixedHeader.classList.remove(defaultHeader);

      //fixedHeader.classList.add(headerHidden);
      //body.classList.add(noHeader);
    }

    lastPosition = currentPosition;
  }

  window.addEventListener('scroll', scroll);
  scroll();

})();

(function () {
  const popupOpeners = document.querySelectorAll('[data-menu-trigger]');
  const popup = ('.js-menu-popup');
  const activeClass = ('menu--active');

  if(!popupOpeners) {
    return;
  }

  const triggerClass = function(evt) {
    evt.preventDefault();
    evt.target.closest(popup).classList.toggle(activeClass);
  }

  popupOpeners.forEach((popupOpener) => {
    popupOpener.addEventListener('click', triggerClass);
  })
})();


(function () {
	let navItems = document.querySelectorAll('.site-nav__item');
	let header = document.querySelector('.site-header');
	const hoverClass = 'drop-opened';

	navItems.forEach((navItem) => {
		navItem.addEventListener('mouseover', function() {
			header.classList.add(hoverClass);
		});
		navItem.addEventListener('mouseleave', function() {
			header.classList.remove(hoverClass);
		});
	});

  document.addEventListener('load', function() {
    setTimeout(function() {
      window.dispatchEvent(new Event('resize'));
    },100);
  })
})();

(function () {
  ResponsiveHelper.addRange({
    '..1023': {
      on: function() {
        $('.menu-accordion').slideAccordion({
          allowClickWhenExpanded: false,
          activeClass: 'menu-accordion__active',
          opener: '.menu-accordion__opener',
          slider: '.menu-accordion__slide',
          collapsible: true,
          event: 'click',
          animSpeed: 400
        });
      },
      off: function() {
        $('.menu-accordion').slideAccordion('destroy');
      }
    }
  });
})();
// mobile open close

(function () {
  const openCloseOpeners = document.querySelectorAll('[data-open-close-opener]');

  const openClose = ('[data-open-close]');
  const activeClass = ('slide--disactive');

  if(!openCloseOpeners) {
    return;
  }

  const triggerClasses = function() {
    openCloseOpeners.forEach((openCloseOpener) => {
      if(!openCloseOpener.closest(openClose).classList.contains(activeClass)) {
        openCloseOpener.closest(openClose).classList.add(activeClass);
      }
    });
  }

  const triggerClass = function(evt) {
    evt.preventDefault();
    triggerClasses();
    evt.target.closest(openClose).classList.toggle(activeClass);
  }

  openCloseOpeners.forEach((openCloseOpener) => {
    openCloseOpener.addEventListener('click', triggerClass);
  });

  triggerClasses();
})();

// Scroll to form after challenge

(function () {
  const newsletter = document.querySelector(`[value="newsletter"]`);
  if(!newsletter) {
    return;
  }
  const checkCookies = Cookies.get('save_design');
  const newsletterForm = newsletter.closest(`form`);
  const error = newsletterForm.querySelector(`.input-error-message`);
  const success = newsletterForm.querySelector(`.form-message--success`);

  if(!error && !success || checkCookies) return;

  const formScroll = function() {
    window.scroll({
      top: newsletterForm.offsetTop - 100,
      behavior: `smooth`
    });
  }

  setTimeout(formScroll, 1500);
})();

// accordion

(function () {
  jQuery('.js-accordion').slideAccordion({
    opener: '.js-opener',
    slider: '.js-slide',
    animSpeed: 300,
    activeClass: 'js-slide-active'
  });
})();

// form validate

(function () {
  const $forms = $('.js-validate-form');

  if (!$forms.length) {
    return;
  }

  $forms.on('submit', function (e) {
    let $target = $(e.currentTarget);
    let $radioButtons = $target.find('.js-required-error-message');
    let valid = true;

    $target.find(".js-required-field").each((index, element) => {
      let $element = $(element)
      let value = $element.val();
      let $currentError = $element.closest('.js-required-field-wrapper').find('.js-required-error-message');

      if (!value) {
        valid = false;
        $currentError.removeClass('hide');
        $element.addClass('form__input--error');
      } else {
        $currentError.addClass('hide');
        $element.removeClass('form__input--error');
      }
    });

    return valid;
  });

})();

// Scroll to block from id in URL

const scrollToBlock = function(selector) {
  window.scroll({
    top: document.querySelector(`#${selector}`).offsetTop - 50,
    behavior: 'smooth'
  })
};

(function () {
  const anchors = document.querySelectorAll('a[href^="#"]:not([href="#"]):not(.tab__opener):not([data-fancybox])');

  if(!anchors) return;

  for (let anchor of anchors) {
    anchor.addEventListener('click', function (e) {
      const blockID = anchor.getAttribute('href').split(`#`)[1];
      if(!document.querySelector(`#${blockID}`)) return;

      e.preventDefault()

      scrollToBlock(blockID);
    })
  }
})();

/*(function () {
  const url = window.location.hash.substr(1);

  if(!url) return;

  scrollToBlock(url);
})();*/


// The function actually applying the offset
function offsetAnchor() {
    if(location.hash.length !== 0) {
        window.scrollTo(window.scrollX, window.scrollY - 50);
    }
}

// This will capture hash changes while on the page
window.addEventListener("hashchange", offsetAnchor);

// This is here so that when you enter the page with a hash,
// it can provide the offset in that case too. Having a timeout
// seems necessary to allow the browser to jump to the anchor first.
window.setTimeout(offsetAnchor, 1); // The delay of 1 is arbitrary and may not always work right (although it did in my testing).


// Captures click events of all <a> elements with href starting with #
$(document).on('click', 'a[href*="#"]', function(event) {
  // Click events are captured before hashchanges. Timeout
  // causes offsetAnchor to be called after the page jump.
  window.setTimeout(function() {
    offsetAnchor();
  }, 0);
});

(function () {
  jQuery('[data-animate-to-top]').itemInViewport({
    visibleMode: 3
  });
})();

(function () {
  const playerList = document.querySelectorAll('.player');
  playerList.forEach(player => {
		const newplayer = new Plyr(player, {
			autoplay: true,
			muted: true,
      loop: { active: true }
		});

		newplayer.play();
  });

})();

// accordion

$(function () {
  let switcherHolder = '.carousel-switcher';
  let carouselOptions = {
    slidesToScroll: 1,
    rows: 0,
    arrows: true,
    prevArrow: $('.js-carousel-switcher-prev'),
    nextArrow: $('.js-carousel-switcher-next'),
    dots: false,
    fade: true,
    lazyload: 'ondemand',
    infinite: true,
    draggable: false,
    pauseOnHover: false,
    swipe: false,
    useCSS: true,
    adaptiveHeight: true
  };

  let $testimonials = $('.carousel-testimonials').slick(carouselOptions);
  let $photos = $('.carousel-photos').slick($.extend({}, carouselOptions, {adaptiveHeight: false}));
  let $collectionSet = $('.carousel-collection-set').slick(carouselOptions);

  $photos.css('top', 'calc(50% - '+( $collectionSet.outerHeight() / 2 + $(switcherHolder).outerHeight() / 2 )+'px)');

  $photos.on('lazyLoaded', function() {
    $photos.height($photos.find('.carousel-photos__image').first().height());
    $photos.slick('slickSetOption', {adaptiveHeight: true}).slick('setPosition');
  });

  $(switcherHolder).each(function (){
    let $switcherItems = $(this).find('li a');

    $switcherItems.on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      let $switcherItem = $(this);
      let $switcherItemWrapper = $switcherItem.parent();
      let index = $switcherItemWrapper.index();

      $switcherItems.parent().removeClass('active');
      $switcherItemWrapper.addClass('active');

      $photos.slick('slickGoTo', parseInt(index));
      $testimonials.slick('slickGoTo', parseInt(index));
      $collectionSet.slick('slickGoTo', parseInt(index));
    });
  });

  $('.js-carousel-switcher-prev').on('click', () => {
    $testimonials.slick('slickGoTo', $testimonials.slick('slickCurrentSlide') - 1);
  })

  $('.js-carousel-switcher-next').on('click', () => {
    $testimonials.slick('slickGoTo', $testimonials.slick('slickCurrentSlide') + 1);
  })
});

(function () {
  function initSameHeight() {
    /*jQuery('.js-sm-height').sameHeight({
      elements: '.js-height-sm-element',
      flexible: true,
      //useMinHeight: true,
      multiLine: true
    });*/

    /*jQuery('.js-height').sameHeight({
      elements: '.js-height-element',
      flexible: true,
      useMinHeight: true,
      multiLine: true
    });*/
  }

  jQuery(function() {
    setTimeout(initSameHeight, 2000);
    //initSameHeight();
  });

  //setTimeout(initSmSameHeight, 1800);
  //setTimeout(initSameHeight, 2000);
})();

;(function() {
  const miniCartTrigger = jQuery('[data-mini-cart-trigger]');
  const miniCartActive = 'mini-cart--shown';
  const miniCartParent = jQuery('[data-mini-cart]');
  const cartCount = jQuery('[data-cart-count]');
  const cartFull = jQuery('[data-full-cart-content]');
  const cartEmpty = jQuery('[data-empty-cart-content]');

  jQuery(document).on('cart.requestComplete', function(event, cart) {
    cartCount.html(cart.item_count);

    if (!miniCartParent.hasClass(miniCartActive)) {
      miniCartParent.addClass(miniCartActive);
    }

    if (cart.item_count === 0) {
      cartCount.addClass('hide');
      cartFull.addClass('hide');
      cartEmpty.removeClass('hide');
    } else {
      cartCount.removeClass('hide');
      cartFull.removeClass('hide');
      cartEmpty.addClass('hide');
    }
  });

  function addMiniCartTrigger(e) {
    e.preventDefault();
    miniCartParent.toggleClass(miniCartActive);
  }

  miniCartTrigger.click(addMiniCartTrigger);
}());

;(function() {
  
  const checkoutButton = document.querySelector('[data-step-trigger]');
  const miniCartStepParent = document.querySelector('[data-step-parent]');
  const miniCartStepActive = 'mini-cart-step--shown';
  const miniCartStepTrigger = document.querySelector('[data-mini-cart-step-trigger]');

  function stepTrigger(e) {
    e.preventDefault();
    miniCartStepParent.classList.toggle(miniCartStepActive);
  }

  document.addEventListener('click', function(e) {
    if(e.target.classList.contains("step-trigger")) {
          e.preventDefault();
          e.stopPropagation();
          document.querySelector('[data-step-parent]').classList.toggle("mini-cart-step--shown");
    }
  });

  //checkoutButton.addEventListener('click', stepTrigger);
  miniCartStepTrigger.addEventListener('click', stepTrigger);
}());

(function( $ ) {

/**
 * initMap
 *
 * Renders a Google Map onto the selected jQuery element
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @return  object The map instance.
 */
function initMap( $el ) {

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP,
        styles      : [
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": "100"
                    },
                    {
                        "color": "#6F7A72"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#FFFFFF"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#F7F4F0"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#F7F4F0"
                    },
                    {
                        "lightness": 17
                    },
                    {
                        "weight": 1.2
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#F7F4F0"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#F5F5F5"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#DEDEDE"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#FFFFFF"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#FFFFFF"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#FFFFFF"
                    },
                    {
                        "lightness": 18
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#FFFFFF"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#F2F2F2"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#E2DED8"
                    },
                    {
                        "lightness": 17
                    }
                ]
            }
        ]
    };
    var map = new google.maps.Map( $el[0], mapArgs );

    // Add markers.
    map.markers = [];
    new Promise((resolve, reject) => {
        map.markersCounter = 0;
        $markers.each(function() {
            initMarker( $(this), map, $markers.length, resolve );
        });
    }).then(function () {
        generateListHTML(map.markers);

        // Center map based on markers.
        centerMap( map );
    });


    // Return map instance.
    return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker( $marker, map, markersNum, resolve ) {
	if($marker.data('coordinates') !== undefined && $marker.data('coordinates').length && $marker.data('coordinates').includes(',')) {
		let latlng = $marker.data('coordinates').split(',');
		let location = {
	        lat: parseFloat( latlng[0] ),
	        lng: parseFloat( latlng[1] )
	    }

	    map.setCenter(location);
        var marker = new google.maps.Marker({
            position: location,
            map: map,
            icon: mapMarkerIcon || ''
        });

        marker.title = $marker.data('title') || '';
        marker.address = $marker.data('address') || '';
        marker.state = $marker.data('state') || '';
        marker.url = $marker.data('url') || '';

        // Append to reference for later use.
        map.markers.push( marker );

        // If marker contains HTML, add it to an infoWindow.
        if( $marker.html() ){

            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });

            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open( map, marker );
            });
        } else {

            // Open accordion
            google.maps.event.addListener(marker, 'click', function() {
                $('.retailer-info').removeClass('active');

                var currentRetailer = $('.retailer-info[data-coordinates="'+marker.getPosition().lat()+','+marker.getPosition().lng()+'"]');
                var currentRetailerHolder = currentRetailer.closest('li');

                currentRetailer.addClass('active');

                if (! currentRetailerHolder.hasClass('active')) {
                    currentRetailerHolder.find('.opener').trigger('click');
                }
            });
        }

    	map.markersCounter++;

        if(map.markersCounter == markersNum) {
            resolve();
        }
	} else {
	    // Get position from marker.
	    if($marker.data('address') !== undefined && $marker.data('address').length) {
	        let geocoder = new google.maps.Geocoder();
	        geocoder.geocode( { 'address': $marker.data('address')}, function(results, status) {
	            if (status == google.maps.GeocoderStatus.OK) {
	                map.setCenter(results[0].geometry.location);
	                var marker = new google.maps.Marker({
	                    position: results[0].geometry.location,
	                    map: map,
	                    icon: mapMarkerIcon || ''
	                });

	                marker.title = $marker.data('title') || '';
	                marker.address = $marker.data('address') || '';
	                marker.state = $marker.data('state') || '';
	                marker.url = $marker.data('url') || '';

	                // Append to reference for later use.
	                map.markers.push( marker );

	                // If marker contains HTML, add it to an infoWindow.
	                if( $marker.html() ){

	                    // Create info window.
	                    var infowindow = new google.maps.InfoWindow({
	                        content: $marker.html()
	                    });

	                    // Show info window when marker is clicked.
	                    google.maps.event.addListener(marker, 'click', function() {
	                        infowindow.open( map, marker );
	                    });
	                } else {

	                    // Open accordion
	                    google.maps.event.addListener(marker, 'click', function() {
	                        $('.retailer-info').removeClass('active');

	                        var currentRetailer = $('.retailer-info[data-coordinates="'+marker.getPosition().lat()+','+marker.getPosition().lng()+'"]');
	                        var currentRetailerHolder = currentRetailer.closest('li');

	                        currentRetailer.addClass('active');

	                        if (! currentRetailerHolder.hasClass('active')) {
	                            currentRetailerHolder.find('.opener').trigger('click');
	                        }
	                    });
	                }

	            	map.markersCounter++;
	            } else {
                console.log(status);
                console.log("STATUS");
	            	if (status == google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
	            		setTimeout(function() {
		            		initMarker( $marker, map, markersNum, resolve );
		            	}, 10000);
		            } else {
	                	alert('Geocode was not successful for the following reason: ' + status);
	                }
	            }

	            if(map.markersCounter == markersNum) {
	                resolve();
	            }
	        });

	    }
	}
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap( map ) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

    // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}

function generateListHTML(markers) {
    let listHolder = $('.retailers-holder');
    let ligtboxHolder = $('.all-retailers__list');
    let list = $('<ul class="accordion"></ul>');
    let viewAll = $('<div class="all-retailers__btn-holder"><a href="#all_retailers" class="btn btn--transparent btn--transparent-w" data-fancybox data-options='+"'"+'{"baseClass": "custom-lightbox", "touch": false, "modal": false}'+"'"+'>'+listHolder.data('all-text')+'</a></div>');

    getListItems2(markers, list).then(function () {

        let lightboxList = list.clone();
        ligtboxHolder.html(lightboxList.html()).parent();

        list.slideAccordion({
            opener: '.opener',
            slider: '.slide',
            animSpeed: 300
        });

        listHolder.append(list);
        listHolder.append(viewAll);

    });
}

function getListItems2(markers, list) {
    return new Promise((resolve, reject) => {
        let states = [];
        markers.forEach((marker, index) => {
            if (states[marker.state] == undefined) {
                states[marker.state] = [];
            }
            states[marker.state].push('<div class="retailer-info" data-coordinates="'+marker.getPosition().lat()+','+marker.getPosition().lng()+'">'+(marker.url.length ? '<a href="'+marker.url+'" target="_blank">' : '' )+'<strong>'+marker.title+'</strong>'+(marker.url.length ? '</a>' : '')+'<a href="https://www.google.com/maps/?q='+marker.address+'" target="_blank">'+marker.address+'</a></div>');
        });

        const ordered_states = Object.keys(states).sort().reduce(
		  (obj, key) => {
		    obj[key] = states[key];
		    return obj;
		  },
		  {}
		);

        Object.keys(ordered_states).forEach((state, index) => {
            let retailersHtml = ordered_states[state].join('');
            list.append('<li><a href="#" class="opener" data-allocate-marker data-fancybox-close>'+state+'</a><div class="slide">'+retailersHtml+'</div></li>');
        });

        resolve();

        return list;
    });
}

function getListItems(markers, list) {
    let geocoder = new google.maps.Geocoder();

    var collectItems = new Promise((resolve, reject) => {

        var content = [];
        let counter = 0;

        markers.forEach((marker, index) => {

            geocoder.geocode({
                'latLng': marker.getPosition()
            }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK) {
                  if (results[1]) {
                    let state = '';
                    results[1].address_components.forEach(component => {
                        if (component.types.includes('administrative_area_level_1')) {
                            state = component.long_name;
                        }
                    });
                    if (content[state] == undefined) {
                        content[state] = new Array;
                    }
                    content[state].push({title: marker.title, address: results[1].formatted_address, coordinates: marker.getPosition().lat()+','+marker.getPosition().lng()});
                  } else {
                    alert('No results found');
                  }
                } else {
                  alert('Geocoder failed due to: ' + status);
                }

                counter++;

                if (counter === markers.length) {
                    Object.keys(content).forEach(function(state, index) {
                        let retailers = content[state];
                        let retailersHtml = '';

                        retailers.forEach(retailer => {
                            retailersHtml += '<div class="retailer-info" data-coordinates="'+retailer.coordinates+'"><strong>'+retailer.title+'</strong><span>'+retailer.address+'</span></div>';
                        });

                        list.append('<li><a href="#" class="opener" data-allocate-marker data-fancybox-close>'+state+'</a><div class="slide">'+retailersHtml+'</div></li>');
                    });

                    resolve();
                }


        	});

        });

        return list;
    });

    return collectItems;

}

// Render maps on page load.
$(document).ready(function(){
    $('.map').each(function(){
        var map = initMap( $(this) );
    });
});

})(jQuery);
// init tabs

(function () {
  jQuery('.tabset').tabset({
    tabLinks: 'a:not(.tabless)',
    defaultTab: true
  });
})();


/* sort by handler */

/*(function () {
  const pfsToolbar = document.querySelector('.boost-pfs-filter-default-toolbar');

  const timerId = function() {
    const pfsButton = pfsToolbar.querySelector('.boost-pfs-filter-top-sorting-wrapper');

    if(pfsButton) {
      document.onclick = function(event){
        const pfsParent = pfsToolbar.querySelector('.boost-pfs-filter-custom-sorting');

        if(event.target.closest('.boost-pfs-filter-filter-dropdown') === null && !event.target.classList.contains('.boost-pfs-filter-filter-dropdown') && pfsParent.classList.contains('boost-pfs-filter-sort-active-custom')) {
          pfsParent.classList.toggle('boost-pfs-filter-sort-active-custom');
        } else if (event.target.closest('.boost-pfs-filter-top-sorting-wrapper') ||  event.target.classList.contains('boost-pfs-filter-top-sorting-wrapper')) {
          pfsParent.classList.toggle('boost-pfs-filter-sort-active-custom');
        }
      };

      clearInterval(intervalID);
    }
  };

  if(pfsToolbar) {
    intervalID = window.setInterval(timerId, 100);
  }
})();*/

const infoDrawer = function() {
  const infoDrawerTriggerSelector = '[data-info-opener]';
  const infoDrawerActive = 'info-drawer--shown';

  function addInfoDrawerTrigger(e) {
    e.preventDefault();
    const infoTargetValue = jQuery(e.target).data('info-opener');

    if(infoTargetValue) {
      jQuery('[data-info-drawer="' + infoTargetValue +'"]').parent().toggleClass(infoDrawerActive);
      $('html').toggleClass('without-scroll');
    }
  }

  $('body').on('click', infoDrawerTriggerSelector, addInfoDrawerTrigger);
};

infoDrawer();

;(function() {
  const popupOpeners = document.querySelectorAll('[data-popup-trigger]');
  const body = document.querySelector('body');
  const popup = ('[data-popup-parent]');
  const activeClass = ('popup--active');
  const activeClassBody = ('no-scroll');
  var KEY_CODE_ESCAPE = 'Escape';

  if(!popupOpeners) {
    return;
  }

  const triggerClass = function(evt) {
    evt.preventDefault();
    evt.target.closest(popup).classList.toggle(activeClass);
    body.classList.toggle(activeClassBody);
  }

  var onEscPress = function (evt) {
    if (evt.key === KEY_CODE_ESCAPE && document.querySelector('.' + activeClass) ) {
      document.querySelector('.' + activeClass).classList.toggle(activeClass);
      body.classList.toggle(activeClassBody);
    }
  };

  popupOpeners.forEach((popupOpener) => {
    popupOpener.addEventListener('click', triggerClass);
  });

  document.addEventListener('keydown', onEscPress);
}());

/* replace social links to full */

(function () {
  const sharingLinks = document.querySelectorAll('[data-social-href]');

  if(!sharingLinks.length) {
    return;
  }

  const searchUrl = window.location.search;
  const hashUrl = window.location.hash;
  let addUrl = searchUrl + hashUrl;
  const realProductUrl = Cookies.get('realProductUrl');
  if (realProductUrl !== undefined && realProductUrl.length) {
    addUrl = theme.routes.root+realProductUrl;
  }

  sharingLinks.forEach(function(link) {
    const share = link.getAttribute('data-social-href');
    const newShare = share.replace('***', addUrl);
    link.setAttribute('href', newShare);
  });
})();

;(function() {
  const submitButton = document.querySelector('[data-submit-design]');
  const submitDesignButton = document.querySelector('[data-save-page]');
  const openSuccessButton = document.querySelector('[data-save-page-popup-trigger]');
  const errorClass = 'input--error';
  const errorInputList = document.querySelectorAll('[data-error]');
  const checkCookies = Cookies.get('save_design');
  const formValidate = Cookies.get('form_validate');

  if(!submitButton) {
    return;
  }

  const search = window.location.search.replace('?', '');

  if(search === 'customer_posted=true' && checkCookies) {
    Cookies.set('form_validate', 'customer_posted=true');

    document.location.href = checkCookies;
  } else if(checkCookies && !formValidate) {
    Cookies.set('form_validate', 'customer_posted=false');

    document.location.href = checkCookies;
  }

  if(formValidate === 'customer_posted=true') {
    openSuccessButton.click();

    Cookies.remove('save_design');
    Cookies.remove('form_validate');
  }

  if(formValidate === 'customer_posted=false') {
    submitDesignButton.click();

    errorInputList.forEach(function(input) {
      input.classList.add(errorClass);
    });

    Cookies.remove('save_design');
    Cookies.remove('form_validate');
  }

  const setCookie = function() {
    const url = window.location.href;

    Cookies.set('save_design', url);
  }

  submitButton.addEventListener('click', setCookie);
}());

$(function() {
  setTimeout(function() {
    $('.dp_hint_button img').each(function() {
      var $img = $(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      $.get(imgURL, function(data) {
        // Get the SVG tag, ignore the rest
        var $svg = jQuery(data).find('svg');

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');

        // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
        if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
          $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
        }

        // Replace image with new SVG
        $img.replaceWith($svg);

      }, 'xml');

    });
  }, 2500);

  $('.img-to-svg').each(function() {
      var $img = $(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      $.get(imgURL, function(data) {
        // Get the SVG tag, ignore the rest
        var $svg = jQuery(data).find('svg');

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');

        // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
        if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
          $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
        }

        // Replace image with new SVG
        $img.replaceWith($svg);

      }, 'xml');

    });
});
/*$(function() {
  $('.map-link').on('click', function(e) {
    if( /Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      e.preventDefault();

      window.open($(this).attr('href').replace('https','maps'));
    }
  });
});*/
(function () {
  let goBackLink = jQuery('.js-go-back-link');

  goBackLink.on('click', function (e) {
    e.preventDefault();
    history.back()
  });
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});


$(function() {
  $('[data-inquire]').on('change', function() {
    let $select = $(this);

    if($select.val() !== '') {
      $.fancybox.open({
        src: '#inquire_form',
        type : 'inline',
        afterShow: function() {
          $('#inquire_form #inquire_product').val($('[data-custom-title]').text());
          $('#inquire_form #inquire_subject').val($select.val());
        }
      });
    }
  });
});

$(document).ready(function () {
  $(document).on('submit', "form[data-ajax]", function (e) {
    e.preventDefault();

    const $form = $(this);
    let formData = $form.serialize();

    $.ajax({
      type: $form.attr('method') || 'POST',
      url: $form.attr('action'),
      data: formData,
      success: function () {
        $form.removeClass('form-error');
        $form.addClass('form-success');
      },
      error: function () {
        $form.removeClass('form-success');
        $form.addClass('form-error');
      }
    });
  });
});

$(function() {
  const sidebar  = document.querySelector('.js-images-sticky');
  const relative = document.querySelector('[data-sticky-container]');

  const Stuck = StuckJs.Stuck;
  const instances = new Stuck([
    { selector: '.js-images-sticky', wrapper: '[data-sticky-container]' },
  ], { marginTop: 70 });
});


$(function(){
    const opener = $(".fixed-content-opener");
    const close = $(".hero__fixed-content-close");
    const fixedContent = $(".hero__fixed-content");
    if (close) {
      close.on("click", function(e){
          e.preventDefault();
        	fixedContent.removeClass("active");
      })
    }
		if (opener && fixedContent) {
			opener.on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
				fixedContent.toggleClass("active");
			});
		}

    $("body").on('click', function(){
      if (fixedContent.hasClass("active")) {
        	$(this).siblings(".hero__fixed-content").toggleClass("active");
      }
    });

    fixedContent.on('click', function(e){
      e.stopPropagation();
    });
})

// $(function() {
//   const container = document.querySelector('.js-images-sticky-wrapper');
//   const stickyElement = document.querySelector('.js-images-sticky');
//
//   document.addEventListener('scroll', function() {
//     const containerRect = container.getBoundingClientRect();
//     const stickyElementRect = stickyElement.getBoundingClientRect();
//
//     if (containerRect.top <= stickyElementRect.top && containerRect.bottom >= stickyElementRect.bottom) {
//       stickyElement.style.top = `${81 - containerRect.top}px`
//     }
//   });
// });
$(function(){
  $(document).ready(function () {
    $(".search-open-close").on("click", function (e) {
      e.preventDefault();
      $(".search-wrapper").toggleClass("active");
      $(".site-links__item.custom-link").toggleClass("hidden");
    });
  })
});

$(function(){
    $(document).ready(function () {
      $(".hero__fixed-content-slider").slick({
          vertical: true,
          verticalSwiping: true,
          infinite: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 2
            }
          }, {
            breakpoint: 600,
            settings: {
              slidesToShow: 1.4,
              slidesToScroll: 1
            }
          }]
      })
      var maxHeight = -1;
      $(".hero__fixed-content-slider .slick-slide").each(function () {
        if ($(this).height() > maxHeight) {
          maxHeight = $(this).height();
        }
      });
      $(".hero__fixed-content-slider .slick-slide").each(function () {
        if ($(this).height() < maxHeight) {
          $(this).css(
            "margin",
            Math.ceil((maxHeight - $(this).height()) / 2) + "px 0"
          );
        }
		});

    });
})